import React from 'react';
import { Box, Typography, Avatar, Stack, Link, Divider } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';

const CompanyList = ({
    companies,
    onAccessClick,
    onEditClick,
    onDeactivateClick,
}) => {
    return (
        <Box>
            {companies.map((company) => (
                <Box
                    key={company.id}
                    sx={{
                        backgroundColor: 'white',
                        padding: 2,
                        borderRadius: 2,
                        boxShadow: 1,
                        mb: 2,
                        textAlign: 'center',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mb: 1,
                        }}
                    >
                        <Avatar
                            src={company.photoUrl}
                            alt={company.name}
                            sx={{ width: 64, height: 64 }}
                        />
                    </Box>

                    <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 600, fontSize: '15px' }}
                    >
                        {company.name}
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 2 }}
                    >
                        {company.userCount} usuários ativos
                    </Typography>

                    <Divider sx={{ mb: 1 }} />

                    <Stack direction="row" justifyContent="center" spacing={3}>
                        <Link
                            component="button"
                            underline="none"
                            onClick={() => onAccessClick(company)}
                            sx={{ color: '#1F83FF', fontSize: '14px' }}
                        >
                            Acessos
                        </Link>
                        <Link
                            component="button"
                            underline="none"
                            onClick={() => onEditClick(company)}
                            sx={{ color: '#1F83FF', fontSize: '14px' }}
                        >
                            <EditIcon style={{ height: 14, marginRight: 4 }} />
                            Editar
                        </Link>
                        <Link
                            component="button"
                            underline="none"
                            onClick={() => onDeactivateClick(company)}
                            sx={{ color: '#1F83FF', fontSize: '14px' }}
                        >
                            <PowerSettingsNewIcon
                                fontSize="small"
                                sx={{ verticalAlign: 'middle', mr: 0.5 }}
                            />
                            Desativar
                        </Link>
                    </Stack>
                </Box>
            ))}
        </Box>
    );
};

export default CompanyList;
